import { Survey } from '@/shared/types/Survey';

export const getSurvey = (surveys: Survey[], surveyId: Survey['id']) => {
  if (!surveys) {
    return;
  }
  return surveys.find((survey) => survey.id === surveyId);
};
